module.exports = __webpack_public_path__ + "img/logo_argus_full.778f9ec3.png";